const STORAGE_KEY = 'arena_tracking_token'

const TOKEN_PARAM_NAMES = [
  'token',
  'postbackToken',
  'tid',
  'click_id',
  'externalid'
] as const

export const captureTrackingTokenFromUrl = (
  searchParams: URLSearchParams
): string | null => {
  for (const name of TOKEN_PARAM_NAMES) {
    const raw = searchParams.get(name)
    const trimmed = raw?.trim()
    if (trimmed) {
      try {
        localStorage.setItem(STORAGE_KEY, trimmed)
      } catch {}
      return name
    }
  }
  return null
}

export const getTrackingToken = (): string | undefined => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)?.trim()
    return stored ? stored : undefined
  } catch {
    return undefined
  }
}

export const trackingTokenPayload = (): { tracking_token?: string } => {
  const token = getTrackingToken()
  return token ? { tracking_token: token } : {}
}

export const trackVisit = (token: string): void => {
  const base = process.env.NEXT_PUBLIC_API_URL
  if (!base || !token) return
  const url = `${base}/api/v2/tracking/visit?token=${encodeURIComponent(token)}`
  try {
    void fetch(url, { method: 'GET', keepalive: true }).catch(() => {})
  } catch {}
}
